import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './css/FuneralInfo.styl';
import InfoButtons from './InfoButtons';
import {formatPhoneNumber} from '../../../../../appModules/utilities/formatHelpers';
import {getMapUrl} from '../../../../shared/utilities/urlHelpers';

export class FuneralInfo extends Component {
  render() {
    const {
      funeralHomeId,
      name,
      profileData: {address1, address2, phone},
      isPremium,
      location: {
        city: {fullName: city},
        state: {code: state},
        postalCode,
      },
    } = this.props.funeralHome;
    const formattedPhone = formatPhoneNumber(phone);
    const googleMapsAddressLink = getMapUrl(
      `${address1}+${city}+${state}+${postalCode}`
    );

    return (
      <div className="funeral-info">
        <h1 className="funeral-home-title" itemProp="name">
          {name}
        </h1>
        <div
          data-testid="fh-address"
          itemProp="address"
          itemScope
          itemType="http://schema.org/PostalAddress"
        >
          <a
            className={classNames('address', address2 ? 'addressMargin' : '')}
            target="_blank"
            href={googleMapsAddressLink}
            itemProp="url"
          >
            <span itemProp="streetAddress">{address1}</span>,&nbsp;
            <span itemProp="addressLocality">{city}</span>,&nbsp;
            <span itemProp="addressRegion">{state}</span>&nbsp;
            <span itemProp="postalCode">{postalCode}</span>
          </a>
          {address2 && <div className="address2">{address2}</div>}
        </div>
        <InfoButtons
          phone={formattedPhone}
          isPremium={isPremium}
          funeralHomeId={funeralHomeId}
        />
      </div>
    );
  }
}

FuneralInfo.propTypes = {
  funeralHome: PropTypes.object.isRequired,
};

export default FuneralInfo;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/FuneralInfo/index.js